import { generateStructureKey } from '../../../../core/structure/StructureKeyGen';

/*
    Hier werden aus einem Daten-Array und dem Kopfzeilen-Index
    die Spalten der Tabelle inkl. der Datentypen ermittelt (letzterer so gut wie möglich)
*/


export function structureFromImport(entityKey: string, entityName: string, data: Array<any>, titleRow: number[]) {
    const structData: any = {};
    const startAt = Math.max(...titleRow) + 1;
    const titles = extractTitles(data, titleRow);
    const typeInfo = retrieveFieldTypes(data, startAt, titles);
    const countInfo = typeInfo.countInfo;
    const types = typeInfo.types;
    console.log('Kopfzeilen'  , titles);
    console.log('Typen'  , types);
    structData[entityKey] =  {
        SRC: {
            id: entityKey,
            type: 'USER'
        },
        NAME: entityName,
        TITEL: entityName,
        ATTS: buildAtts(titles, types)
    };
    return {structData, countInfo};
}
function buildAtts(titles: Array<string>, types: Array<string>) {
    const atts: Array<any> = [];
    const keys: any = {};
    titles.forEach ((t: string, idx: number) => {
        let key = generateStructureKey(t);
        if (keys[key]) {
            key += 'A';
        }
        const att = {
            KEY: key,
            NAME: t,
            FORMAT: 'NONE',
            HIDDEN: '0',
            SUMMARY: 'NONE',
            TYPE: types[idx]
        };
        atts.push(att);
    });
    return atts;
}
function retrieveFieldTypes(data: Array<Array<any>>, startAt: number, titles: Array<string>) {
    // Wir gehen alle Zeilen ab Start durch
    const types: Array<string> = [];
    const countInfo: Array<any> = [];
    titles.forEach ((t: string, idx: number) => {
        // Wir wollen nur den Titel wissen
        const counts: any = {};
        for (let i = startAt; i < data.length; i++) {
            const value = data[i][idx];
            const type = guessType(value);
            if (!counts[type]) {
                counts[type] = 1;
            } else {
                counts[type]++;
            }
            // console.log( value + ' = ' + type);
        }
        let maxType = undefined;
        let maxCount = 0;
        Object.keys(counts).forEach((key: string) => {
            const count = counts[key];
            if (count > maxCount) {
                maxCount = count;
                maxType = key;
            }
        });
        types[idx] = maxType ? maxType : 'CHAR100';
        countInfo[idx] = counts;
    });
    return {countInfo, types};
}
function guessType (value: any) {
    if (isNaN(value)) {
        return 'CHAR100';
    }
    const min_timestamp = 946684800; // 1.1.2000
    const max_timestamp = 1893456000; // 1.1.2030
    const timestamp = ((+value - (25567 + 2)) * 86400);
    if (timestamp > min_timestamp && timestamp < max_timestamp) {
       return 'DATE';
    }
    if (Number.isInteger(+value)) {
        return 'INT';
    }
    return 'DOUBLE'; // Geht ja nicht anders
}

function extractTitles(data: Array<Array<any>>, titleRow: number[]) {
    const titles: Array<string> = [];
    titleRow.forEach((n: number) => {
        const rowData = data[n];
        rowData.forEach((value: any, idx: number) => {
            if (value && value !== '') {
                if (!titles[idx]) {
                    titles[idx] = value;
                } else {
                    titles[idx] += value;
                }
            }
        });
    });
    return titles;
}
